'use strict'

import cloneDeep from 'lodash/cloneDeep'
import {buildNetsuiteTransactionUrl} from '@/util/netsuiteLinks'

export const DEFAULT_DEMO_NETSUITE_APP_URL = 'https://3373346-sb2.app.netsuite.com'

export const NETSUITE_SO_STATUSES = Object.freeze({
  PENDING_FULFILLMENT: Object.freeze({id: 'B', refName: 'Pending Fulfillment'}),
  PENDING_BILLING: Object.freeze({id: 'F', refName: 'Pending Billing'}),
  VOIDED: Object.freeze({id: 'VOIDED', refName: 'Voided'}),
})

export const buildDemoSalesOrderIdentity = (masterLotCode, appUrl) => {
  const suffix = numericLotSuffix(masterLotCode)
  const demoSequence = String(390000 + suffix).padStart(6, '0')
  const netsuiteInternalId = String(99000000 + suffix)
  return {
    netsuite_internalId: netsuiteInternalId,
    tranId: `SO${demoSequence}`,
    url: buildNetsuiteTransactionUrl(appUrl, netsuiteInternalId),
    status: cloneDeep(NETSUITE_SO_STATUSES.PENDING_FULFILLMENT),
  }
}

export const requireActiveSalesOrder = (masterLot) => {
  const salesOrder = masterLot?.salesOrder
  if (!salesOrder?.netsuite_internalId || !salesOrder?.tranId || !salesOrder?.url) {
    throw new Error('active NetSuite sales order required')
  }
  if (String(salesOrder.netsuite_internalId) === salesOrder.tranId) {
    throw new Error('NetSuite sales order internal id must differ from tranId')
  }
  return salesOrder
}

export const archiveActiveSalesOrder = (masterLot, {reason, at}) => {
  const active = requireActiveSalesOrder(masterLot)
  const existingSync = cloneDeep(masterLot.netsuiteSync || {})
  const salesOrderSync = cloneDeep(existingSync.salesOrder || {})
  const history = Array.isArray(salesOrderSync.history) ? salesOrderSync.history : []
  return {
    ...cloneDeep(masterLot),
    salesOrder: null,
    netsuiteSync: {
      ...existingSync,
      salesOrder: {
        ...salesOrderSync,
        history: [
          ...history,
          {
            ...cloneDeep(active),
            status: cloneDeep(NETSUITE_SO_STATUSES.VOIDED),
            voidedAt: at,
            voidReason: reason,
          },
        ],
      },
    },
  }
}

const numericLotSuffix = (masterLotCode) => {
  const match = String(masterLotCode || '').match(/(?:D)?(\d+)$/u)
  if (!match) throw new Error('master lot code with numeric suffix required')
  return Number(match[1])
}
